import { defineStore } from 'pinia'

// 加载状态管理
export const useLoadingStore = defineStore('loading', {
  state: () => ({
    // 记录当前正在进行的请求数量
    requestCount: 0,
    // 记录上传相关的请求
    uploadRequests: new Set(),
    // 全局加载状态
    isLoading: false,
    // 上传中状态
    isUploading: false
  }),

  getters: {
    // 是否有请求正在进行
    hasPendingRequests: (state) => state.requestCount > 0 || state.uploadRequests.size > 0
  },

  actions: {
    // 开始请求
    startRequest(requestId, isUpload = false) {
      this.requestCount++
      this.isLoading = true
      
      // 如果是上传请求，添加到上传请求集合
      if (isUpload) {
        this.uploadRequests.add(requestId)
        this.isUploading = true
      }
    },

    // 结束请求
    endRequest(requestId, isUpload = false) {
      this.requestCount = Math.max(0, this.requestCount - 1)
      this.isLoading = this.requestCount > 0
      
      // 如果是上传请求，从集合中移除
      if (isUpload) {
        this.uploadRequests.delete(requestId)
        this.isUploading = this.uploadRequests.size > 0
      }
    },

    // 清除所有请求状态
    clearAll() {
      this.requestCount = 0
      this.uploadRequests.clear()
      this.isLoading = false
      this.isUploading = false
    }
  }
})